import type { ReactNode } from 'react';
import React, { memo } from 'react';

import type { TooltipProps } from '@mui/material';
import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

interface CustomTooltipProps extends Omit<TooltipProps, 'children'> {
  variant?: 'default' | 'secondary';
  children: ReactNode;
}

const StyledTooltip = styled(
  ({ className, variant: _variant, ...props }: CustomTooltipProps & { className?: string }) => (
    <Tooltip
      {...(props as TooltipProps)}
      // Reduce default listeners to avoid excessive event churn across large tables
      arrow
      disableFocusListener
      disableTouchListener
      classes={{ popper: className }}
      enterDelay={150}
    />
  )
)(({ theme, variant = 'default' }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: variant === 'default' ? theme.palette.gx.highlight : theme.palette.gx.response
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: variant === 'default' ? theme.palette.gx.highlight : theme.palette.gx.response,
    fontSize: '12px',
    borderLeft: variant === 'secondary' ? `1px solid ${theme.palette.gx.highlight}` : 'none'
  }
}));

const CustomTooltip = ({ children, variant = 'default', ...props }: CustomTooltipProps) => (
  <StyledTooltip
    {...props}
    variant={variant}
  >
    {children}
  </StyledTooltip>
);

export default memo(CustomTooltip);
